<app-aktarildi-isaretle-modal [source]="faturaId" [show]="showAktarildiIsaretleModalTs" (updateList)="updateLists()">
</app-aktarildi-isaretle-modal>

<div class="table-responsive" *ngIf="faturalar">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
      <tr>
        <th class="w-1">Id</th>
        <th>Tarih</th>
        <th>FaturaNo</th>
        <th>Talep No</th>
        <th>Firma Adı</th>
        <th>Mal veya Hizm. Cinsi</th>
        <th>Mal veya Hizm. Miktari</th>
        <th>Durum</th>
        <th>Toplam Tutar</th>
        <th>Oluşturan Kullanıcı</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let f of faturalar">
        <tr
          [class]="(f.durum === DURUM_ONAY_SURECI && f.faturaOnaySeviye?.kullaniciGrup?.id === userGrupId) ? 'bg-orange text-white' : ''">
          <td><span class="text-muted">{{f.id}}</span></td>
          <td>{{ f.tarih | date:'dd.MM.yyyy' }}</td>
          <td [class]="f.talepId !== null ? 'bg-primary text-white' : ''">{{ f.faturaNo }}</td>
          <td [class]="f.talepId !== null ? 'bg-primary text-white' : ''">{{ f.talep?.talepNo }}</td>
          <td>{{ f.firmaAdi }}</td>
          <td>{{ f.malHizmetCinsi }}</td>
          <td>{{ f.malHizmetMiktar }}</td>
          <td>{{ f.durumText }}</td>
          <td>{{ f.toplamTutar}} {{ f.paraBirimi }}</td>
          <td>{{ f.kullanici?.adSoyad }}</td>
          <td class="text-right">
            <div class="btn btn-sm btn-success" (click)="incele(f)">İncele</div>
            <div *ngIf="!f.netsiseIslendi && f.durum === 1" class="btn btn-sm btn-info ml-3"
              (click)="netsiseAktar(f.id)">
              Netsise Aktar</div>
            <div class="btn btn-sm btn-danger ml-3" (click)="iptalEt(f.id)">
              İptal Et</div>
            <!--*ngIf="iptalEdilebilir(f)"-->
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>